/**
 * Fixed site-header behaviour:
 *  - adds `.is-scrolled` once the page is scrolled (subtle shadow)
 *  - hides on scroll-down, shows again on scroll-up (`.is-hidden`)
 *
 * Respects prefers-reduced-motion: the hide/show is skipped, the header
 * simply stays put (the CSS also neutralises the transform there).
 */
export function initHeaderScroll() {
  const header = document.querySelector('[data-site-header]');
  if (!header) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const REVEAL_ZONE = 8;      // px of jitter to ignore
  const HIDE_AFTER = 120;     // don't hide until scrolled past this

  let lastY = window.scrollY;
  let ticking = false;

  const update = () => {
    const y = Math.max(0, window.scrollY);

    header.classList.toggle('is-scrolled', y > 4);

    if (!reduceMotion) {
      const delta = y - lastY;
      if (Math.abs(delta) > REVEAL_ZONE) {
        const goingDown = delta > 0 && y > HIDE_AFTER;
        header.classList.toggle('is-hidden', goingDown);
        lastY = y;
      }
    }
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  update();
}
